'use client';

import React, { useEffect, useState } from 'react';
import { createClient } from '@/utils/supabase/client';
import styles from '../styles/ReviewsSection.module.css';

export default function ReviewAvatar({ storedImage, size = 32 }) {
  const [avatarUrl, setAvatarUrl] = useState('/images/demo-profile.png');

  useEffect(() => {
    const downloadImage = async (path) => {
      const supabase = createClient(); // Create fresh client with current auth context
      try {
        const { data, error } = await supabase.storage
          .from('avatars')
          .download(path);
        if (error) throw error;
        setAvatarUrl(URL.createObjectURL(data));
      } catch {
        setAvatarUrl('/images/demo-profile.png');
      }
    };

    if (storedImage && storedImage !== '/images/demo-profile.png') {
      // If it's already a full URL (signed URL from server), use directly
      if (storedImage.startsWith('http')) {
        setAvatarUrl(storedImage);
        return;
      }
      // Otherwise, attempt client-side download from storage
      downloadImage(storedImage);
    } else {
      setAvatarUrl('/images/demo-profile.png');
    }
  }, [storedImage]);

  return (
    <img
      src={avatarUrl}
      alt="Avatar"
      className={styles.reviewerAvatar}
      style={{ width: size, height: size }}
    />
  );
}